import type { AppContext } from 'next/app';

const routerRewrites = (appContext: AppContext, serverContext: any) => {
  const { res, pathname } = appContext.ctx;

  if (!res) {
    return;
  }

  if (pathname === '/portfolio') {
    const isPortfolioVisible =
      serverContext.publicUser?.preferences?.portfolio_visible;

    if (!isPortfolioVisible) {
      res.writeHead(302, { location: '/' });
      res.end();
    }
  }

  if (pathname === '/gift-cards') {
    const isGiftCardsVisible =
      serverContext.publicUser?.preferences?.gift_card_purchase_enabled;

    if (!isGiftCardsVisible) {
      res.writeHead(302, { location: '/' });
      res.end();
    }
  }

  // Users have to start at `/services` to get to `/book` and '/multi-book'
  if (pathname === '/book' || pathname === '/multi-book') {
    res.writeHead(302, { location: '/services' });
    res.end();
  }
};

export default routerRewrites;
